<template>
    <app-modal :modal-id="modalId" :modal-size="modalSize" :modal-alignment="modalAlignment" :modal-scroll="false"
        :modal-body-class="'w-full max-w-full wizard-steps'" @close-modal="closeModal">
	
        <template slot="header">
            <h5 class="modal-title">
                {{ modalTitle }}
            </h5>
            <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close"
                @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
		<app-overlay-loader v-if="preloader" />
		<template slot="body" v-if="!preloader">
			<div class="row" >
				<div class="col-md-12">
					<table class="table-info-student">
						<tr>
							<td>Student ID</td>
							<td>:</td>
							<td style="min-width: 17%;">{{studentData.student_id}}</td>
							<td>School Name</td>
							<td>:</td>
							<td style="min-width: 112px;">{{studentData.school.name}}</td>
						</tr>
						<tr>
							<td>Student Name</td>
							<td>:</td>
							<td>{{studentData.full_name}}</td>
							<td>School Level</td>
							<td>:</td>
							<td>{{studentData.school_level.name}}</td>
						</tr>
					</table>
				</div>
			</div>
			<hr style="border-top: 2px solid black; font-weight: bold; margin-top: 20px !important;margin-bottom: 10px !important;" />
			<div class="row">
				<div class="col-md-12">
					<app-breadcrumb page-title="App Submition" />
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<table class="table-app-submition" :class="{ 'loading-opacity': preloader }">
						<tr>
							<th>Meaning App</th>
							<th>Reading App</th>
							<th>Result</th>
						</tr>
						<tr>
							<td :style="getBackgroundStyle(app_submition?.meaning_app)">
								{{ formatPercent(app_submition?.meaning_app) }}</td>
							<td :style="getBackgroundStyle(app_submition?.reading_app)">
								{{ formatPercent(app_submition?.reading_app) }}</td>
							<td>{{ app_submition?.result ?? '-' }}</td>
						</tr>
					</table>
				</div>
			</div>
			<hr style="border-top: 2px solid black; font-weight: bold; margin-top: 20px !important;margin-bottom: 10px !important;" />
			<div class="row">
				<div class="col-md-12">
					<app-breadcrumb page-title="Report Progress" />
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<table class="table-app-progress" :class="{ 'loading-opacity': preloader }">
						<tr>
							<th >MA (Total)</th>
							<th >MA (Remaining)</th>
							<th >RA (Main TB+Ext)</th>
							<th >RA (Remaining)</th>
							<th >Done</th>
						</tr>
						<tr>
							<td :style="getBackgroundStyle(report_progress?.meaning?.progress)">
								{{ formatPercent(report_progress?.meaning?.progress) }}</td>

							<td :style="getBackgroundStyle(report_progress?.meaning?.remaining)">
								{{ formatPercent(report_progress?.meaning?.remaining) }}</td>

							<td :style="getBackgroundStyle(report_progress?.reading?.progress)">
								{{ formatPercent(report_progress?.reading?.progress) }}</td>

							<td :style="getBackgroundStyle(report_progress?.reading?.remaining)">
								{{ formatPercent(report_progress?.reading?.remaining) }}</td>
							<td>{{report_progress?.result ?? '-'}}</td>
						</tr>
					</table>
				</div>
			</div>
		</template>
    </app-modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";


export default {
	name: "AppsDetail",
	mixins: [FormMixin, ModalMixin],
	props: {
		modalId: String,
        CourseName: null,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			studentData:[],
			app_submition:[],
			report_progress:[],
			preloader: true,
			formData:{},
            modalSize: 'extra-large',
            modalAlignment: 'top',
		};
	},
    computed: {
        modalTitle() {
            return `Report Apps`;
        }
    },
	created() {
	},
	methods: {

		getTimeByDay(classItem, day) {
			if (classItem.day == day) {
    			return classItem.time_start.slice(0,5) + ' - ' + classItem.time_end.slice(0,5);
			}
			return '';
		},
        formatPercent(val) {
            if (val === null || val === undefined || val === '') return '-'
            return val + '%'
        },
        getBackgroundStyle(val) {
            if (val === null || val === undefined || val === '') return {}

            const number = Number(val)

            if (number >= 90) {
                return { backgroundColor: 'yellow' }
            }
            if (number < 60) {
                return { backgroundColor: '#ffa6a6', color: 'black' }
            }
            if (number < 80) {
                return { backgroundColor: '#aedef6', color: 'black' }
            }
            if (number < 90) {
                return { backgroundColor: '#aaf495', color: 'black' }
            }

            return {}
        },
		
		afterSuccessFromGetEditData(response) {
			this.studentData = response.data.data.student;
			this.app_submition = response.data.data.app_submition;
			this.report_progress = response.data.data.report_progress;
			this.preloader = false;
		},
	},
};
</script>

<style scoped>
	.table-info-student{
		width: 70%;
		margin-bottom: 20px;	
	}
	.table-info-student td{
		text-wrap: nowrap;
		padding-right: 10px;
	}
	
    .table-app-submition th{
        text-align: inherit;
        background: #4466F2;
        color: white;
        padding: 10px;
        border: 1px solid white;
    }
    .table-app-submition td{
        text-align: center;
        padding: 10px;
        background: #dbdbdb;
        border: 1px solid white;
    }
	
    .table-app-progress th{
        text-align: inherit;
        background: #4466F2;
        color: white;
        padding: 10px;
        border: 1px solid white;
    }
    .table-app-progress td{
        text-align: center;
        padding: 10px;
        background: #dbdbdb;
        border: 1px solid white;
    }
    .table-app-progress span{
        font-weight: 400;
        font-size: 12px;
    }
</style>